export default __webpack_public_path__ + "static/media/robotic_process_automation.0261873f.png";